import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  empty: {
    fontSize: theme.size.sm,
    color: '#657786',
    userSelect: 'none'
  }
}))

export default useStyles
